import axios from 'axios'

import { HttpService } from './http.service'
import {
  IHomePageSetingsResponse,
  IPopularProductsResponse,
  IPublicAccountsResponse,
  IPublicProductsResponse,
} from 'src/types'

class CommonService extends HttpService {
  constructor() {
    super(axios)
  }

  getHomePageSetings() {
    return this.get<IHomePageSetingsResponse>(`home/settings`)
  }


  getPopularProducts(params: { pageSize?: number } = {}) {
    return this.get<IPopularProductsResponse>('home/products/popular', { params })
  }

  getPublicProducts(params: { page?: number; pageSize?: number; search?: string } = {}) {
    return this.get<IPublicProductsResponse>('home/products', {
      params: { sortBy: 'created_at', sortOrder: 'DESC', ...params },
    })
  }

  getPublicAccounts(params: { page?: number; pageSize?: number; search?: string, aiSearch?: boolean } = {}) {
    return this.get<IPublicAccountsResponse>('home/accounts', {
      params: { sortBy: 'relevance', sortOrder: 'DESC', ...params },
    })
  }
}

export const commonService = new CommonService()
